module.exports = __webpack_public_path__ + "static/020.thumb-a5b3d9d2ef9659014b372eaf1815c037.jpg";